<template>
  <div>
    <apexchart
      v-if="isLoaded"
      type="rangeBar"
      height="450"
      :options="chartOptions"
      :series="seriesApex"
    />
    <slot name="loading" v-else>
      <v-progress-linear
        indeterminate
        color="warning"
        top
      />
    </slot>
  </div>
</template>

<script>
import ru from 'apexcharts/dist/locales/ru.json'
import moment from 'moment'
import { mapActions } from 'vuex'
import { axios } from '~/plugins/axios'

export default {
  name: 'TimelineCharts',
  props: {
    data: {
      type: Object,
      default() {
        return {
          agent: "7123",
          period: [
            "2022-11-11 00:00:00",
            "2022-11-11 23:59:59"
          ]
        }
      }
    },
    sum: Boolean,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 300,
          type: 'rangeBar',
          background: '#00000000',
          events: {
            zoomed: this.eventHandler,
            dataPointSelection: this.eventHandler,
          },
          locales: [ru],
          defaultLocale: 'ru',
          
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%'
          }
        },
        xaxis: {
          type: 'datetime'
        },
        stroke: {
          show: false,
          // width: 1
        },
        fill: {
          type: 'solid',
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },

        theme: {
            mode: 'light', 
        },

        tooltip: {
          custom({y1, y2, ctx, dataPointIndex}) {
            let date = moment.utc(y1).format('DD/MM');
            let n1 = moment.utc(y1).format('HH:mm:ss');
            let n2 = moment.utc(y2).format('HH:mm:ss');
            let category = ctx.data.twoDSeriesX[dataPointIndex];
            let duration = moment.utc(y2).subtract(moment.utc(y1)).format('HH:mm:ss');

            return `<div class="apexcharts-tooltip-rangebar">
                      <span>
                        ${category} <br>
                        Дата: ${date} <br>
                        ${n1} - ${n2} <br>
                        Длительность: ${duration} <br>
                      </span>
                    </div>`;
          },
          // x: {
          //   format: 'HH:mm:ss',
          // },
        },
      },

      seriesApex: null,

      formula: [],
      isLoaded: false,
    }
  },

  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },
  },

  watch: {
    isDarkTheme(curr) {
      // fucking apex :(
      let mode = curr ? 'dark' : 'light';
      this.chartOptions = {
        chart: {
          background: '#00000000'
        },
        theme: {mode}
      };
    },
  },

  methods: {
    ...mapActions({
      loadTimeline: 'timeline/loadTimeline',
      clearTimeline: 'timeline/clearTimeline',
      setSuccess: 'shared/setSuccess',
      setError: 'shared/setError'
    }),
    
    getApexSeries(operator) {
      let res =  [{
        // name: operator.agent,
        data: [],
      }]

      let colors = {
        increase: '#28A745',
        decrease: '#2196F3',
        ignore: '#555555',
        result: '#9820f3',
      }

      let formula = this.formula; //костылик в getColor надо прокинуть как-то
      formula.push({
        "name": "Результат",
        "type": "result",
        "action": "result"
      })

      // собираем массив для апекса
      operator.sessions?.map(el => {
        add(el, 'Сессии', getColor('Сессии'));
      })
      operator.unreachables?.map(el => {
        add(el, 'Отвалы', getColor('Отвалы'));
      })
      operator.incomingCalls?.map(el => {
        add(el, 'Входящие вызовы', getColor('Входящие вызовы'));
      })
      operator.outgoingCalls?.map(el => {
        add(el, 'Исходящие на внешние номера', getColor('Исходящие на внешние номера'));
      })
      operator.outgoingLocalCalls?.map(el => {
        add(el, 'Исходящие на внутренние номера', getColor('Исходящие на внутренние номера'));
      })
      operator.outboundCalls?.map(el => {
        add(el, 'Вызовы исходящей кампании', getColor('Вызовы исходящей кампании'));
      })
      operator.result?.periods?.map(el => {
        add(el, 'Результат', getColor('Результат'));
      })
      for (const key in operator.pauses) {
        if (!key) continue;
        const pause = operator.pauses[key];
        pause.items.map(el => {
          add(el, pause.dname, getColor(pause.dname));
        })
      }

      // сортируем массив для апекса
      res[0].data.sort((a,b) => {
        let a1 = formula.findIndex(el => el.name === a.x);
        let b1 = formula.findIndex(el => el.name === b.x);
        return a1 - b1;
      })

      return res;


      function add(period, x, fillColor) {
        let seriesData = {
          x,
          y: [
            new Date(period.start).getTime() + 10800000,
            new Date(period.end).getTime() + 10800000,
          ]
        }
        if (fillColor) {
          seriesData.fillColor = fillColor;
          // seriesData.strokeColor = fillColor + '70'; //alpha to stroke
        }
        
        res[0].data.push(seriesData)
      }

      function getColor(name) {
        let type = formula.find(el => el.name === name).action
        return colors[type]
      }
    },

    eventHandler(ev, {data}, point) {
      if (!point) return
      let index = point.dataPointIndex;
      let cat = data.twoDSeriesX[index]
      let n1 = data.w.globals.initialSeries[0].data[index].y[0]
      let n2 = data.twoDSeries[index]
      let date = moment.utc(n1).format('DD/MM')

      let d1 = moment.utc(n1).format('HH:mm:ss')
      let d2 = moment.utc(n2).format('HH:mm:ss')
      let duration = moment.utc(n2).subtract(moment.utc(n1)).format('HH:mm:ss');

      let str = `${cat}\nДата: ${date}\n${d1} - ${d2}\n`
      str += `Длительность: ${duration}`
      window.navigator.clipboard.writeText(str).then(() => {
        this.setSuccess({message: 'Скопировано в буфер'});
      }, (err) => {
        this.setError({message: err});
      })
    },
  },

  async mounted() {
    // тема чартов по человечески не работает (((
    if (this.isDarkTheme) {
      let options = this.chartOptions;
      options.theme.mode = 'dark';
      this.chartOptions = Object.assign(this.chartOptions, options);
    }
    
    let formula = await axios.get('/api/formulasManager')
      .then(resp => resp.data.data);
    formula = formula.find(f => f.name === 'utilization');
    formula = JSON.parse(formula.content);
    this.formula = formula;

    let payload = Object.assign(this.data, {code: 'employment', sum: this.sum});
    let operator = await this.loadTimeline(payload);
    this.seriesApex = this.getApexSeries(operator);

    this.isLoaded = true;
  },

  beforeDestroy() {
    this.clearTimeline()
  },
}
</script>

<style>

</style>